import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { Sector } from '../models/sector.model';
import { URLS } from '../../../shared/constants/api-request.urls';

@Injectable({
  providedIn: 'root',
})
export class SectorService {
  constructor(private http: HttpClient) {}

  getSectors(pageNumber: number, pageSize: number): Observable<any> {
    const params = new HttpParams()
      .set('pageNumber', pageNumber)
      .set('pageSize', pageSize)
      .set('mode', 'edit');
    return this.http.get(`${URLS.SECTOR}`, {
      params,
    });
  }

  getSectorsLookup(): Observable<any> {
    return this.http.get(`${URLS.SECTOR}?mode=lookup`).pipe(
      map((response: any) => {
        return response.data;
      })
    );
  }

  getSectorById(id: string): Observable<any> {
    return this.http.get(`${URLS.SECTOR}/${id}?mode=edit`);
  }

  createSector(sector: Sector): Observable<any> {
    return this.http.post(URLS.SECTOR, sector);
  }

  updateSector(id: string, sector: Sector): Observable<any> {
    return this.http.put(`${URLS.SECTOR}/${id}`, sector);
  }

  deleteSector(id: string): Observable<any> {
    return this.http.delete(`${URLS.SECTOR}/${id}`);
  }

  // Template related methods
  getTemplates(): Observable<any> {
    return this.http.get(URLS.TEMPLATE);
  }

  getTemplateById(id: string, isEditMode: boolean = false): Observable<any> {
    const params = new HttpParams().set('IsEditMode', isEditMode.toString());
    return this.http.get(`${URLS.TEMPLATE}/${id}`, { params });
  }

  searchSectors(params: any): Observable<any> {
    return this.http.post(`${URLS.SECTOR}/Search`, params);
  }
}
